// Маршрутизатор: маршруты из файлов src/routes (TanStack Router, генератор в vite.config.ts),
// кэш запросов в контексте, общие экраны 404, ошибки и загрузки. «Страница не найдена» у
// вошедшего пользователя — внутри каркаса (FR-036, T102): неизвестный адрес верхнего уровня
// маршрутизатор отдаёт корню, а не маршруту каркаса _app, поэтому каркас собирает сам экран
// (NotFoundPage). Маршрут, который ждёт сервер дольше 0,3 с, показывает скелет страницы
// (FR-040а); первая загрузка каркаса — заглушку каркаса (_app, pendingComponent).
import { LOADING_DELAY_MS } from '@kp/ui';
import { createRouter } from '@tanstack/react-router';
import type { RouterHistory } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from '../routeTree.gen.ts';
import { NotFoundPage } from '../shell/NotFoundPage.tsx';
import { PagePending } from '../shell/ShellSkeleton.tsx';
import { ErrorScreen } from './ErrorScreens.tsx';

export function createAppRouter(queryClient: QueryClient, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context: { queryClient },
    ...(history ? { history } : {}),
    // Данные свежит TanStack Query, маршрутизатор их не держит.
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    defaultNotFoundComponent: NotFoundPage,
    defaultErrorComponent: ErrorScreen,
    defaultPendingComponent: PagePending,
    defaultPendingMs: LOADING_DELAY_MS,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
  interface StaticDataRouteOption {
    /** Крошка в шапке листа: «Пользователи». */
    crumb?: string;
  }
}
